module.exports = __webpack_public_path__ + "img/works_orangelife_btm_off.2c0dc1ca.jpg";